// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.styled-table th,
.styled-table td {

  padding: 8px;
}

.styled-table th {
  background-color: #f2f2f2;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.sortable-header:hover {
  background-color: #e9ecef;
}

.badge.bg-success-app {
  background-color: #28a745;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Announcement/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".styled-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.styled-table th,\r\n.styled-table td {\r\n\r\n  padding: 8px;\r\n}\r\n\r\n.styled-table th {\r\n  background-color: #f2f2f2;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.sortable-header:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.badge.bg-success-app {\r\n  background-color: #28a745;\r\n  color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
